import { Icon } from "@coverme/icons";
import moment from "moment";
import React from "react";
import * as PropTypes from "prop-types";
import { isNotNullOrWhitespace, isNullOrWhitespace } from "../../services/stringService";

export function MiniFacesheetDemographicInfo(props) {
    const score = props.score == null || isNaN(props.score) ? "-" : props.score;

    return (
        <>
            <h4 className="mini-facesheet__title">
                <span className="mini-facesheet__avatar">
                    <Icon icon={"avatar"} color={"greyDark"} height={35} width={35} />
                </span>
                {props.entry.patient.firstName} {props.entry.patient.middleInitial} {props.entry.patient.lastName}{" "}
                {props.entry.patient.suffix}
            </h4>
            <div className="mini-facesheet__info">
                <div className="mini-facesheet__info-item">
                    <h5 className="h5">Confidence Score </h5>
                    <span className="p-regular">{score}</span>
                </div>
                <div className="mini-facesheet__info-item">
                    <h5 className="h5">DOB </h5>
                    <span className="p-regular">{moment(props.entry.patient.dob).format("MM.D.YYYY")}</span>
                </div>
                <div className="mini-facesheet__info-item">
                    <h5 className="h5">SSN </h5>
                    {isNullOrWhitespace(props.entry.patient.ssn) && <span className="p-regular">N/A</span>}
                    {isNotNullOrWhitespace(props.entry.patient.ssn) && (
                        <span className="p-regular">xxx-xx-{props.entry.patient.ssn.slice(-4)}</span>
                    )}
                </div>
                <div className="mini-facesheet__info-item">
                    <h5 className="h5">Gender </h5>
                    <span className="p-regular">{props.entry.patient.gender}</span>
                </div>
                {!isNullOrWhitespace(props.entry.patient.email) && (
                    <div className="mini-facesheet__info-item">
                        <h5 className="h5">Email </h5>
                        <span className="p-regular">{props.entry.patient.email}</span>
                    </div>
                )}
            </div>
        </>
    );
}

MiniFacesheetDemographicInfo.propTypes = { entry: PropTypes.any };
